import { AxiosInstance } from 'axios';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (email: string) => {
  const response = await api.post(url, {
    Email: email,
  });
  return toResponse(response.data);
};



// WEBPACK FOOTER //
// ./src/services/api/user/passwordChange/request.ts